import { isSupplierId } from '@bridebook/toolbox/src/is';
import { md5 } from 'js-md5';

/**
 * Returns a conversation id created as a hash from an array of ids
 */
export const getConversationId = (participantIds: string[]) => {
  // Sort alphabetically first, then prioritize supplier IDs at the beginning
  const sortedIds = participantIds
    // Sort alphabetically first
    .sort()
    // Then prioritize supplier IDs at the beginning
    // This is to maintain backward compatibility with existing conversations (supplier + wedding), where supplier IDs are always first
    .sort((a, b) => {
      const aIsSupplier = isSupplierId(a);
      const bIsSupplier = isSupplierId(b);

      if (aIsSupplier && !bIsSupplier) return -1;
      if (!aIsSupplier && bIsSupplier) return 1;
      return 0;
    });

  return md5(sortedIds.join('-'));
};
